// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M12 3a9 9 0 100 18 9 9 0 000-18zm-.964 4.5a.964.964 0 011.928 0v3.857a.964.964 0 11-1.928 0V7.5zM12 17.143a1.286 1.286 0 110-2.573 1.286 1.286 0 010 2.573z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;